import { cn } from '@avanta/shared/utils/cn';
import { Root, Indicator } from '@radix-ui/react-progress';
import { type ReactElement } from 'react';
import { progressVariants } from './styles';
import { type ProgressProps } from './types';

export const Progress = ({ className, value, ...props }: ProgressProps): ReactElement => (
  <Root data-slot="progress" className={cn(progressVariants(), className)} {...props}>
    <Indicator
      data-slot="progress-indicator"
      className="bg-teal-600 h-full w-full flex-1 transition-all"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </Root>
);
